import React from 'react';
import { View, Image, StyleSheet, Text } from 'react-native';
import { COLOR } from '../../../constants/styles';

export const PlusView = function (props) {
  const containerStyle = props.style;
  let plusIconStyle = null;
  if (containerStyle && containerStyle.width) {
    const dim = parseInt(containerStyle.width * 0.57);
    plusIconStyle = { width: dim, height: dim };
  }

  return (
    <View style={[styles.container, containerStyle]}>
      <Image
        style={[styles.plusIcon, plusIconStyle]}
        source={require('../../../../resources/plus.png')}
        resizeMode="contain"
      />
    </View>
  );
};

export const MinusView = function (props) {
  const containerStyle = props.style;
  let iconStyle = null;
  if (containerStyle && containerStyle.width) {
    const dim = parseInt(containerStyle.width * 0.57);
    iconStyle = { width: dim, height: dim };
  }

  return (
    <View style={[styles.container, styles.minusContainer, containerStyle]}>
      <Image
        style={[styles.minusIcon, iconStyle]}
        source={require('../../../../resources/minus.png')}
        resizeMode="contain"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 28,
    height: 28,
    borderRadius: 5,
    backgroundColor: COLOR.button,
    justifyContent: 'center',
    alignItems: 'center',
  },
  plusIcon: {
    width: 16,
    height: 16,
    tintColor: 'white',
  },
  minusContainer: {
    // justifyContent: 'center',
  },
  minusIcon: {
    width: 16,
    height: 2,
    tintColor: 'white',
    // backgroundColor: 'pink',
  },
});
